import { render, staticRenderFns } from "./BizCustomsInfo.vue?vue&type=template&id=321cd756&scoped=true"
import script from "./BizCustomsInfo.vue?vue&type=script&lang=js"
export * from "./BizCustomsInfo.vue?vue&type=script&lang=js"
import style0 from "./BizCustomsInfo.vue?vue&type=style&index=0&id=321cd756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321cd756",
  null
  
)

export default component.exports